/**
 * parseFrac(str) → número decimal
 *
 * Acepta cualquiera de estos formatos:
 *   "3.5"        → 3.5
 *   "3 1/2"      → 3.5
 *   "1/4"        → 0.25
 *   "5/8"        → 0.625
 *   "49.21"      → 49.21
 *   ""  / null   → 0
 *
 * Ignora espacios extra y es tolerante a comas decimales.
 */
export function parseFrac(str) {
  if (!str && str !== 0) return 0;
  const s = String(str).trim().replace(',', '.');

  // Entero + fracción:  "3 1/2"  o  "3-1/2"
  const mixedMatch = s.match(/^(\d+[\d.]*)\s*[-\s]\s*(\d+)\s*\/\s*(\d+)$/);
  if (mixedMatch) {
    const whole = parseFloat(mixedMatch[1]);
    const num   = parseFloat(mixedMatch[2]);
    const den   = parseFloat(mixedMatch[3]);
    return den !== 0 ? whole + num / den : whole;
  }

  // Fracción simple: "5/8"
  const fracMatch = s.match(/^(\d+)\s*\/\s*(\d+)$/);
  if (fracMatch) {
    const num = parseFloat(fracMatch[1]);
    const den = parseFloat(fracMatch[2]);
    return den !== 0 ? num / den : 0;
  }

  // Número decimal o entero normal
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}
